var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full font-bold uppercase py-1 px-2 text-xs",class:_vm.themeClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }